"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NTAQualifiedInvoiceIssuerUpdateStatus = exports.NTAQualifiedInvoiceIssuerCountry = exports.NTAQualifiedInvoiceIssuerKind = exports.NTAQualifiedInvoiceIssuerCorrect = exports.NTAQualifiedInvoiceIssuerProcess = exports.NTACorporateInfoKind = exports.NTACorporateInfoProcess = void 0;
/**
 * An `NTACorporateInfoProcess` represents the reason why the record
 * was added.
 */
var NTACorporateInfoProcess;
(function (NTACorporateInfoProcess) {
    /**
     * Indicates new record.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["NEW"] = 1] = "NEW";
    /**
     * Indicates trade name or corporate name was changed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["NAME_CHANGED"] = 11] = "NAME_CHANGED";
    /**
     * Indicates domestic address was changed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["DOMESTIC_ADDRESS_CHANGED"] = 12] = "DOMESTIC_ADDRESS_CHANGED";
    /**
     * Indicates overseas address was changed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["OVERSEAS_ADDRESS_CHANGED"] = 13] = "OVERSEAS_ADDRESS_CHANGED";
    /**
     * Indicates registration record was closed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["REGISTRATION_RECORD_CLOSED"] = 21] = "REGISTRATION_RECORD_CLOSED";
    /**
     * Indicates registration record was reopened.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["REGISTRATION_RECORD_REOPENED"] = 22] = "REGISTRATION_RECORD_REOPENED";
    /**
     * Indicates absorption merger completed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["ABSORPTION_MERGER_COMPLETED"] = 71] = "ABSORPTION_MERGER_COMPLETED";
    /**
     * Indicates absorption merger was invalidated.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["ABSORPTION_MERGER_INVALIDATED"] = 72] = "ABSORPTION_MERGER_INVALIDATED";
    /**
     * Indicates registration record was erased.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["REGISTRATION_RECORD_ERASED"] = 81] = "REGISTRATION_RECORD_ERASED";
    /**
     * Indicates the record was deleted.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["DELETED"] = 99] = "DELETED";
})(NTACorporateInfoProcess = exports.NTACorporateInfoProcess || (exports.NTACorporateInfoProcess = {}));
/**
 * A `NTACorporateInfoKind` represents the kind of corporate.
 */
var NTACorporateInfoKind;
(function (NTACorporateInfoKind) {
    /**
     * National public entity
     */
    NTACorporateInfoKind[NTACorporateInfoKind["NATIONAL_PUBLIC_ENTITY"] = 101] = "NATIONAL_PUBLIC_ENTITY";
    /**
     * Local public entity
     */
    NTACorporateInfoKind[NTACorporateInfoKind["LOCAL_PUBLIC_ENTITY"] = 201] = "LOCAL_PUBLIC_ENTITY";
    /**
     * Limited liability company by share, aka K.K.
     */
    NTACorporateInfoKind[NTACorporateInfoKind["KABUSHIKI_KAISHA"] = 301] = "KABUSHIKI_KAISHA";
    /**
     * Old style of limited liability company not by share
     */
    NTACorporateInfoKind[NTACorporateInfoKind["YUGEN_KAISHA"] = 302] = "YUGEN_KAISHA";
    /**
     * General partnership company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["GOMEI_KAISHA"] = 303] = "GOMEI_KAISHA";
    /**
     * Limited partnership company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["GOSHI_KAISHA"] = 304] = "GOSHI_KAISHA";
    /**
     * Limited liability company, aka G.K.
     */
    NTACorporateInfoKind[NTACorporateInfoKind["GODO_KAISHA"] = 305] = "GODO_KAISHA";
    /**
     * Other types of company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["OTHER_COMPANY"] = 399] = "OTHER_COMPANY";
    /**
     * Foreign company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["FOREIGN_COMPANY"] = 401] = "FOREIGN_COMPANY";
    /**
     * Other corporate kinds which do not belong to the above
     */
    NTACorporateInfoKind[NTACorporateInfoKind["OTHER"] = 499] = "OTHER";
})(NTACorporateInfoKind = exports.NTACorporateInfoKind || (exports.NTACorporateInfoKind = {}));
/**
 * An `NTAQualifiedInvoiceIssuerProcess` specifies the state of the registration.
 */
var NTAQualifiedInvoiceIssuerProcess;
(function (NTAQualifiedInvoiceIssuerProcess) {
    /**
     * Implies that the record is newly registered.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["NEW"] = 1] = "NEW";
    /**
     * Implies that the record has been changed.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["INFORMATION_CHANGED"] = 2] = "INFORMATION_CHANGED";
    /**
     * Implies that the registration has been expired.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["REGISTRATION_EXPIRED"] = 3] = "REGISTRATION_EXPIRED";
    /**
     * Implies that the registration has been invalidated.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["REGISTRATION_DISPOSED"] = 4] = "REGISTRATION_DISPOSED";
    /**
     * Implies that the registration has been deleted.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["DELETED"] = 99] = "DELETED";
})(NTAQualifiedInvoiceIssuerProcess = exports.NTAQualifiedInvoiceIssuerProcess || (exports.NTAQualifiedInvoiceIssuerProcess = {}));
/**
 * An `NTAQualifiedInvoiceIssuerCorrect` implies the reason for the change,
 * if the record has been updated.
 */
var NTAQualifiedInvoiceIssuerCorrect;
(function (NTAQualifiedInvoiceIssuerCorrect) {
    /**
     * Not the correction.
     */
    NTAQualifiedInvoiceIssuerCorrect[NTAQualifiedInvoiceIssuerCorrect["OTHER"] = 0] = "OTHER";
    /**
     * Correction.
     */
    NTAQualifiedInvoiceIssuerCorrect[NTAQualifiedInvoiceIssuerCorrect["CORRECTION"] = 1] = "CORRECTION";
})(NTAQualifiedInvoiceIssuerCorrect = exports.NTAQualifiedInvoiceIssuerCorrect || (exports.NTAQualifiedInvoiceIssuerCorrect = {}));
/**
 * An `NTAQualifiedInvoiceIssuerKind` specifies the kind of the invoice issuer.
 */
var NTAQualifiedInvoiceIssuerKind;
(function (NTAQualifiedInvoiceIssuerKind) {
    /**
     * Implies that the record is for a sole proprietor.
     */
    NTAQualifiedInvoiceIssuerKind[NTAQualifiedInvoiceIssuerKind["INDIVIDUAL"] = 1] = "INDIVIDUAL";
    /***
     * Implies that the record is for a corporate entity.
     */
    NTAQualifiedInvoiceIssuerKind[NTAQualifiedInvoiceIssuerKind["CORPORATION"] = 2] = "CORPORATION";
})(NTAQualifiedInvoiceIssuerKind = exports.NTAQualifiedInvoiceIssuerKind || (exports.NTAQualifiedInvoiceIssuerKind = {}));
/**
 * An `NTAQualifiedInvoiceIssuerCountry` specifies whether the issuing entity is domestic or not,
 * and if domestic, whether it is specifically designated by the National Tax Agency.
 */
var NTAQualifiedInvoiceIssuerCountry;
(function (NTAQualifiedInvoiceIssuerCountry) {
    /**
     * Implies that the record is for a domestic entity
     */
    NTAQualifiedInvoiceIssuerCountry[NTAQualifiedInvoiceIssuerCountry["DOMESTIC_ENTITY"] = 1] = "DOMESTIC_ENTITY";
    /**
     * Implies that the record is for a designated foreign entity.
     */
    NTAQualifiedInvoiceIssuerCountry[NTAQualifiedInvoiceIssuerCountry["DESIGNATED_FOREIGN_ENTITY"] = 2] = "DESIGNATED_FOREIGN_ENTITY";
    /**
     * Implies that the record is for a general (not specifically designated) foreign entity.
     */
    NTAQualifiedInvoiceIssuerCountry[NTAQualifiedInvoiceIssuerCountry["GENERAL_FOREIGN_ENTITY"] = 3] = "GENERAL_FOREIGN_ENTITY";
})(NTAQualifiedInvoiceIssuerCountry = exports.NTAQualifiedInvoiceIssuerCountry || (exports.NTAQualifiedInvoiceIssuerCountry = {}));
/**
 * An `NTAQualifiedInvoiceIssuerUpdateStatus` specifies whether the record is latest or obsolete.
 */
var NTAQualifiedInvoiceIssuerUpdateStatus;
(function (NTAQualifiedInvoiceIssuerUpdateStatus) {
    /**
     * Implies that the record is obsolete
     */
    NTAQualifiedInvoiceIssuerUpdateStatus[NTAQualifiedInvoiceIssuerUpdateStatus["OBSOLETE"] = 0] = "OBSOLETE";
    /**
     * Implies that the record is the latest one.
     */
    NTAQualifiedInvoiceIssuerUpdateStatus[NTAQualifiedInvoiceIssuerUpdateStatus["LATEST"] = 1] = "LATEST";
})(NTAQualifiedInvoiceIssuerUpdateStatus = exports.NTAQualifiedInvoiceIssuerUpdateStatus || (exports.NTAQualifiedInvoiceIssuerUpdateStatus = {}));
